module.exports = __webpack_public_path__ + "img/Micro-Lin carpet cutting line visual detection and positioning software V1.0.8f2fa827.png";